import { RatingLevel } from '@core/interview-results-types';

export const mapStringToRating = (name: RatingLevel): RatingLevel => {
  const ratingMap = {
    strong_yes: RatingLevel.StrongYes,
    yes: RatingLevel.Yes,
    neutral: RatingLevel.Neutral,
    no: RatingLevel.No,
  };

  return ratingMap[name];
};
